<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="50%" @open="addOpen" :close-on-click-modal="false">
    <el-form :model="formData" :rules="addFormRules" ref="addFormRef" label-width="120px">
      <el-form-item label="日期" prop="day_time">
        <el-date-picker
          v-model="formData.day_time"
          type="date"
          value-format="timestamp"
          placeholder="选择日期"></el-date-picker>
      </el-form-item>
      <el-form-item label="图片" prop="pic">
        <template>
          <el-upload
            class="avatar-uploader"
            action="/proxy/admin/upload_light_reading"
            name="file"
            :show-file-list="false"
            :on-success="handleSuccess">
            <img v-if="picUrl" :src="picUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </template>
      </el-form-item>
      <el-form-item label="章节" prop="chapter">
        <el-input v-model="formData.chapter"></el-input>
      </el-form-item>
      <el-form-item label="经文" prop="content">
        <el-input v-model="formData.content" type="textarea" :rows="3"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="addConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'category_add',
  props: [
    'visible', 'id'
  ],
  data () {
    return {
      title: '添加每日背经',
      formData: {
        day_time: 0,
        chapter: '',
        content: '',
        pic: ''
      },
      picUrl: '',
      addFormRules: {
        chapter: [
          { required: true, message: '章节不能为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '经文不能为空', trigger: 'blur' }
        ],
        pic: [
          { required: true, message: '图片不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    closeDialog () {
      this.$refs.addFormRef.resetFields()
      this.picUrl = ''
      this.$emit('closeDialog')
    },
    addConfirm () {
      this.$refs.addFormRef.validate(valid => {
        if (!valid) return
        // 验证通过
        if (this.id === 0) {
          this.$emit('add', this.formData)
        } else {
          this.$emit('update', this.id, this.formData)
        }
      })
    },
    addOpen () {
      // 如果id>0,则是编辑信息
      if (this.id > 0) {
        this.title = '编辑每日背经'
        this.getInfo(this.id)
      } else {
        this.title = '添加每日背经'
      }

      if (this.formData.day_time === 0) {
        this.formData.day_time = new Date(new Date().toLocaleDateString()).getTime()
      }
    },
    async getInfo (id) {
      const res = await this.$http.get('/admin/light_reading_daily/info/' + id)
      if (res.code === 0) {
        this.formData = {
          chapter: res.data.chapter,
          day_time: res.data.day_time * 1000,
          content: res.data.content,
          pic: res.data.pic
        }
        this.picUrl = res.data.pic_url
      }
    },
    handleSuccess (resp, file, fileList) {
      if (resp.code === 0) {
        this.picUrl = resp.data.url
        this.formData.pic = resp.data.path
      } else {
        this.$message.error(resp.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
